module.exports = __webpack_public_path__ + "img/business-chart1.c5662d9a.png";